export const LogsPath = "/logs";
export const TeamsPath = "/teams";
export const CodeManagementPath = "/code-management";
export const AuthorizationPath = "/authorization";
export const AcknowledgePath =
  "/generic/alertCorrelationId=:alertCorrelationId&accountId=:accountId";
